/* ATN CyberMall — Section 02 Pavilions: arrows-only scroller (no drag, links safe) */
(function () {
  function initPav(root) {
    if (!root || root.__pavInit) return;
    root.__pavInit = true;

    var strip = root.querySelector('[data-pav-strip]');
    var prev = root.querySelector('[data-pav-prev]');
    var next = root.querySelector('[data-pav-next]');
    if (!strip) return;

    function step() {
      var card = strip.querySelector('.atn-cm-pav-card');
      var gap = parseInt(getComputedStyle(strip).columnGap || getComputedStyle(strip).gap, 10) || 16;
      var w = card ? card.getBoundingClientRect().width : 200;
      return (w + gap) * 2;
    }

    function update() {
      var overflow = strip.scrollWidth > strip.clientWidth + 4;
      root.classList.toggle('has-overflow', overflow);
      if (prev) prev.disabled = strip.scrollLeft <= 2;
      if (next) next.disabled = strip.scrollLeft >= (strip.scrollWidth - strip.clientWidth - 2);
    }

    if (prev) prev.addEventListener('click', function () {
      strip.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      strip.scrollBy({ left: step(), behavior: 'smooth' });
    });

    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(strip);
    }
    update();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-pav-root]');
    for (var i = 0; i < roots.length; i++) initPav(roots[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pav-root]');
    if (r) initPav(r);
  });
})();